// extracted by mini-css-extract-plugin
export var content = "_m8-1";
export var fullScreen = "_m8-0";